import { Component, OnInit, Inject } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { OsaExecucaoFolhaTesteService } from "./../../../../../services/osa-execucao-folha-teste.service";
import { IOsaExecucaoFolhaTesteModel, IOsaExecucaoFolhaTesteQuestaoPapelTrabalhoModel } from "./../../../../../models/osa-execucao-folha-teste-model";
import { OsaExecucaoService } from "./../../../../../services/osa-execucao.service";
import { MatDialog, MatDialogConfig, MatDialogRef, MAT_DIALOG_DATA } from "@angular/material/dialog";


@Component({
  selector: 'app-osa-execucao-aba-folha-teste-imprimir',
  templateUrl: './osa-execucao-aba-folha-teste-imprimir.component.html',
  styleUrls: ['./osa-execucao-aba-folha-teste-imprimir.component.scss']
})
export class OsaExecucaoAbaFolhaTesteImprimirComponent implements OnInit {

  public model: IOsaExecucaoFolhaTesteModel = {} as IOsaExecucaoFolhaTesteModel;
  public questoes: any;
  public numeroOsa: any;
  public id: number = 0;
  public cancelado: boolean = false;

  constructor(
    public matDialog: MatDialog,
    private router: Router,
    public route: ActivatedRoute,
    private osaExecucaoFolhaTesteService: OsaExecucaoFolhaTesteService,
    private osaExecucaoService: OsaExecucaoService,
    private dialogRef: MatDialogRef<OsaExecucaoAbaFolhaTesteImprimirComponent>,
    @Inject(MAT_DIALOG_DATA) public data) {
    this.id = data?.id;
    this.numeroOsa = data?.numeroOsa;
  }

  ngOnInit(): void {
    this.getFolhaTeste(this.id);
  }

  getFolhaTeste(Id: number) {

    this.osaExecucaoFolhaTesteService
      .obterFolhaTestePorId(this.id)
      .then((res) => {
        this.model = res.dados;
        this.cancelado = res.dados.status === 4;
      })
      .catch((err) => {
      })
  }

  getEvidencias(evidencias: IOsaExecucaoFolhaTesteQuestaoPapelTrabalhoModel[]): string {

    if (!evidencias?.length) return ' ';
    return evidencias
      .map(a => a.osaExecucaoPapelTrabalho.nomePapel)
      .join('<br>');
  }

  onImprimir() {
    // opcional — pode deixar vazio, o print já é interno
  }

  onFechar() {
    this.dialogRef.close();
  }

}

